// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "+3908118097112",
  numero_telefono: "tel:+3908118097112",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */


  urlWeb: 'https://ergonformazione.discentya.it/',
  urlMaterialeDidattico: 'https://ergonformazione.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://ergonformazione.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://ergonformazione.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://ergonformazione.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://ergonformazione.discentya.it/api/',

  urlStampa: 'https://ergonformazione.discentya.it/stampe/',

  urlAttestati: 'https://ergonformazione.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://ergonformazione.discentya.it/pages/certificate/',
  urlImagePartners: 'https://ergonformazione.discentya.it/assets/media/partners/',
  urlImageMedia: 'https://ergonformazione.discentya.it/assets/media/',

};

